import React from 'react';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import { StyledButton, STYLED_BUTTON_TYPE, STYLED_BUTTON_SIZE } from 'taboola-ultimate-ui';
import styles from './clearButton.module.scss';

const classNameBuilder = classnames.bind(styles);

const ClearButton = ({ children, onClick, className }) => (
    <StyledButton
        className={classNameBuilder('button', className)}
        type={STYLED_BUTTON_TYPE.BORDERLESS_ICON}
        size={STYLED_BUTTON_SIZE.MEDIUM}
        onClick={onClick}
    >
        {children}
    </StyledButton>
);

ClearButton.propTypes = {
    children: PropTypes.node,
    onClick: PropTypes.func,
    className: PropTypes.string,
};

export default ClearButton;
